<template>
    <td>
        <span v-if="dosageChoice.doseValue && dosageChoice.doseUnit">
            {{ dosageChoice.doseValue }} {{ $t(`unit.${dosageChoice.doseUnit}`) }}
        </span>
        <span v-else>
            &mdash;
        </span>
    </td>

    <td>
        <span v-if="dosageChoice.interval">{{ dosageChoice.interval.toTextString() }}</span>
        <span v-else>&mdash;</span>
    </td>

    <td>
        <span v-if="dosageChoice.doseInfusionTime">{{ dosageChoice.doseInfusionTime.toTextString() }}</span>
        <span v-else>&mdash;</span>
    </td>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { LastingDosage } from '@/service/models/common/query-dosage/dosage-choices/lasting-dosage';

export default defineComponent({
    props: {
        dosageChoice: {
            type: Object as PropType<LastingDosage>,
            required: true,
        },
    },
})
</script>
